import { Task } from '../types/task'
export const mockTasks: Task[] = [
  {
    id: '1',
    fileName: 'INV-2025-09-343.pdf',
    priority: 'high',
    notes: 'Urgent invoice that needs processing by end of day',
    postedAt: '2023-10-01T09:00:00Z',
    postedBy: {
      id: '2',
      name: 'Jane Smith',
    },
    assignedTo: {
      id: '1',
      name: 'John Doe',
    },
    completedAt: null,
  },
  {
    id: '2',
    fileName: 'REP-2025-Q3-Sales.xlsx',
    priority: 'medium',
    notes: 'Quarterly sales report for review',
    postedAt: '2023-09-28T14:30:00Z',
    postedBy: {
      id: '2',
      name: 'Jane Smith',
    },
    assignedTo: {
      id: '1',
      name: 'John Doe',
    },
    completedAt: null,
  },
  {
    id: '3',
    fileName: 'CONTRACT-AcmeCorp-2025.docx',
    priority: 'low',
    notes: 'New client contract for review',
    postedAt: '2023-09-25T11:15:00Z',
    postedBy: {
      id: '3',
      name: 'Robert Johnson',
    },
    assignedTo: {
      id: '1',
      name: 'John Doe',
    },
    completedAt: null,
  },
  {
    id: '4',
    fileName: 'REPORT-Security-Audit-2025.pdf',
    priority: 'high',
    notes: 'Security audit findings that need immediate attention',
    postedAt: '2023-09-22T16:45:00Z',
    postedBy: {
      id: '2',
      name: 'Jane Smith',
    },
    assignedTo: {
      id: '1',
      name: 'John Doe',
    },
    completedAt: null,
  },
  {
    id: '5',
    fileName: 'MEMO-Staff-Meeting-Oct.docx',
    priority: 'medium',
    notes: 'Prepare memo for upcoming staff meeting',
    postedAt: '2023-09-20T10:00:00Z',
    postedBy: {
      id: '3',
      name: 'Robert Johnson',
    },
    assignedTo: {
      id: '1',
      name: 'John Doe',
    },
    completedAt: null,
  },
]
export const mockCompletedTasks: Task[] = [
  {
    id: '6',
    fileName: 'INV-2025-08-299.pdf',
    priority: 'high',
    notes: 'Previous month invoice',
    postedAt: '2023-08-28T09:00:00Z',
    postedBy: {
      id: '2',
      name: 'Jane Smith',
    },
    assignedTo: {
      id: '1',
      name: 'John Doe',
    },
    completedAt: '2023-08-29T14:35:00Z',
  },
  {
    id: '7',
    fileName: 'BUDGET-2025-Planning.xlsx',
    priority: 'medium',
    notes: 'Budget planning document',
    postedAt: '2023-08-15T11:20:00Z',
    postedBy: {
      id: '3',
      name: 'Robert Johnson',
    },
    assignedTo: {
      id: '1',
      name: 'John Doe',
    },
    completedAt: '2023-08-18T16:40:00Z',
  },
]
